import { isAttachmentResponse } from '../../../entities/task/lib/isAttachmentResponse';
import React from 'react';
import { IModalAttachment } from '../../../entities/attachment/model/IModalAttachment.interface';
import { IAttachmentResponse } from '../../../entities/task/model/types/tasks';
import cls from './PreviewerImg.module.css';

interface IPreviewerImgProps {
    previewUrl: string;
    isFromClient: boolean;
    currentFile: IModalAttachment | IAttachmentResponse;
}

export const PreviewerImg = ({ previewUrl, isFromClient, currentFile }: IPreviewerImgProps) => {
    return (
        <img
            className={cls.PreviewerImg}
            src={previewUrl}
            alt={
                isFromClient
                    ? currentFile?.file?.name
                    : isAttachmentResponse(currentFile) && currentFile.name
            }
            onClick={(e) => e.stopPropagation()}
        />
    );
};
